"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _objectHelper = require("@eig-builder/core-utils/helpers/object-helper");

/**
 * Static class that will contain all the translations used in the interface
 *
 * @class Localizations
 */
var Localizations = /*#__PURE__*/function () {
  function Localizations() {
    (0, _classCallCheck2["default"])(this, Localizations);
  }

  (0, _createClass2["default"])(Localizations, null, [{
    key: "append",
    value: function append(obj) {
      this.translations = (0, _merge["default"])(this.translations, obj);
    }
  }, {
    key: "get",
    value: function get() {
      return this.translations;
    }
  }, {
    key: "getFlatten",
    value: function getFlatten() {
      return (0, _objectHelper.flattenObject)(this.get());
    }
  }]);
  return Localizations;
}();

Localizations.translations = {};
var _default = Localizations;
exports["default"] = _default;